
import { Section } from "./data-types";

export const EventsConference: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "cards",
			options: {
				columns: 2,
			},
			items: [
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Conference of Irish Geographers",
						content: () => [
							<p>
								The Conference of Irish Geographers is the annual conference of the Geographical Society of Ireland (GSI),
								in association with the wider geographical community in Ireland.
								Over the years the Conference has played a key role in facilitating networking among the academic,
								policy and practice communities, and has welcomed international colleagues including
								Prof David Harvey, Prof Helga Leitner, Prof Mike Raco, Dr Harriet Hawkins, Prof Nigel Roulet
								and public figures, such as Robert Fisk, as keynote speakers.
							</p>,
							<p>
								Through a varied programme of paper, poster, workshop and fieldtrip sessions as well as social events,
								the Conference of Irish Geographers has become an important and enriching part of the annual activities of the GSI.
								It has become an especially important event at which early career researchers benefit from significant career development opportunities.
							</p>,
							// <p>
							// 	The 56th Conference of Irish Geographers is being hosted by University College Cork, and runs from the 6th-8th of May 2024.
							// </p>,
							// <p>
							// 	You can learn more about our upcoming and previous Annual Conferences through our dedicated <a href="https://www.conferenceofirishgeographers.ie/" target="_blank" rel="noopener noreferrer">CIG website</a>.
							// </p>,
							<p>
								For more information on this year's conference please <a href="https://www.conferenceofirishgeographers.ie/" target="_blank" rel="noopener noreferrer">click here</a>.
							</p>,
							<p>
								<a class="primary-button" href="https://www.conferenceofirishgeographers.ie/" target="_blank" rel="noopener noreferrer">Conference of Irish Geographers</a>
							</p>
						]
					},
				},
				{
					type: "CardImage",
					options: {
					},
					data: {
						media: {
							type: "image",
							src: "/images/examples/3.jpg"
						},
					},
				}
			]
		}
	]
}
